import React from 'react';
import MarketingLayout from '../components/marketing/MarketingLayout';
import PageHero from '../components/marketing/PageHero';
import { IMAGES } from '../lib/marketingImages';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '../components/ui/accordion';
import { SUPPORT_WHATSAPP_URL } from '../config';

const faqs = [
  {
    q: 'How fast do electricity units arrive?',
    a: 'Most prepaid tokens show up on your phone within about 30 seconds after a successful payment. If something stalls, WhatsApp us with your receipt.',
  },
  {
    q: 'Which bills can I pay today?',
    a: 'ESCOM electricity, LWB / BWB / NRWB water, DStv, GOtv, and MRA tax. More household services are on the way.',
  },
  {
    q: 'Do I need a bank account?',
    a: 'You can pay with the methods shown at checkout, including mobile-friendly options via PayChangu. Many customers finish from their phone in one sitting.',
  },
  {
    q: 'Is my PIN and payment data safe?',
    a: 'Yes. Sessions are protected, payments are PIN-gated, and we never ask for your PIN on WhatsApp or by email.',
  },
  {
    q: 'What if I pay the wrong meter?',
    a: 'Always double-check the name on the account before you confirm. Contact support immediately with the receipt if a mistake happens.',
  },
  {
    q: 'Can I pay for family in another city?',
    a: 'Yes. Save extra meters and pay them as easily as your own. Perfect for parents, rentals, and the shop.',
  },
];

export default function HelpPage() {
  return (
    <MarketingLayout>
      <PageHero
        image={IMAGES.womanPhone}
        eyebrow="Help"
        title="Questions? We kept the answers human."
        subtitle="Straight talk about tokens, receipts, and what to do when something feels off."
      />
      <section className="py-16 px-4 max-w-3xl mx-auto">
        <Accordion type="single" collapsible className="space-y-3">
          {faqs.map((faq, i) => (
            <AccordionItem key={faq.q} value={`item-${i}`} className="bg-card border border-border rounded-2xl px-5 border-b-0">
              <AccordionTrigger className="text-left font-semibold">{faq.q}</AccordionTrigger>
              <AccordionContent className="text-muted-foreground">{faq.a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
        <p className="text-center mt-10 text-muted-foreground">
          Still stuck?{' '}
          <a href={SUPPORT_WHATSAPP_URL} className="text-primary font-semibold hover:underline" target="_blank" rel="noopener noreferrer">
            Message us on WhatsApp
          </a>
        </p>
      </section>
    </MarketingLayout>
  );
}
